import { CiApple, CiHome } from "react-icons/ci";
import { TbRibbonHealth, TbToolsKitchen2 } from "react-icons/tb";
import { IoHomeOutline, IoShirtOutline } from "react-icons/io5";
import { GiPressureCooker, GiSmartphone, GiWeightLiftingUp } from "react-icons/gi";
import { HiOutlineComputerDesktop } from "react-icons/hi2";
import { PiTelevision, PiGameController, PiBeerBottleDuotone } from "react-icons/pi";
import { LiaBabySolid } from "react-icons/lia";

/** Icons keyed by category names as stored in the database */
export const CATEGORY_ICON_MAP = {
  "Super Market": <CiApple />,
  Supermarket: <CiApple />,
  "Health & Beauty": <TbRibbonHealth />,
  "Home & Office": <IoHomeOutline />,
  Appliances: <GiPressureCooker />,
  Appliance: <GiPressureCooker />,
  "Phones & Tablets": <GiSmartphone />,
  Computing: <HiOutlineComputerDesktop />,
  Electronics: <PiTelevision />,
  Fashion: <IoShirtOutline />,
  "Baby Products": <LiaBabySolid />,
  "Baby, kids & Toy": <LiaBabySolid />,
  Gaming: <PiGameController />,
  "Sporting Goods": <GiWeightLiftingUp />,
  "Drink & Groceries": <PiBeerBottleDuotone />,
  Grocery: <PiBeerBottleDuotone />,
  "Kitchen Utensils": <TbToolsKitchen2 />,
  "Building Materials": <CiHome />,
  "Building Material": <CiHome />,
};

export const getCategoryIcon = (categoryName) =>
  CATEGORY_ICON_MAP[categoryName] || <CiHome />;

export const CATEGORY_LINK_SKELETON_COUNT = 14;
